import styled from "styled-components";
import { Link as LinkRR } from "react-router-dom";

const Link = styled(LinkRR)`
  text-decoration: none;
  color: white;
`;

export default Link;
